import { SUGGESTION_GROUP_NAMES } from './prepareSuggestions';

export const checkIfOptionMatchesValue = (option: string, value: string) => {
  const optionLowerCase = option.toLowerCase();
  const valueLowerCase = value.toLowerCase();

  return (
    optionLowerCase.startsWith(valueLowerCase) &&
    ![
      SUGGESTION_GROUP_NAMES.HISTORY.toLowerCase(),
      SUGGESTION_GROUP_NAMES.POPULAR.toLowerCase(),
      SUGGESTION_GROUP_NAMES.NEAREST.toLowerCase(),
      SUGGESTION_GROUP_NAMES.RUSSIAN.toLowerCase(),
      SUGGESTION_GROUP_NAMES.OTHER_COUNTRIES.toLowerCase(),
    ].includes(optionLowerCase)
  );
};

export default checkIfOptionMatchesValue;
